import { render, staticRenderFns } from "./DetailTabs.vue?vue&type=template&id=01e881ec&"
import script from "./DetailTabs.vue?vue&type=script&lang=js&"
export * from "./DetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./DetailTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports